import { render, staticRenderFns } from "./groupBuyingAddOrEdit.vue?vue&type=template&id=875401fa"
import script from "./groupBuyingAddOrEdit.vue?vue&type=script&lang=js"
export * from "./groupBuyingAddOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports